<template>
  <span>-----</span>
</template>
<script>
export default {
  name: 'EmptyNumbers'
}
</script>
